import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import Downloader from "../../components/pdf_downloader/Downloader";

export default function Tenders(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Tenders</Typography>
            <hr/>
            <Box sx={{borderLeft:"5px solid #0b4285", padding:"2px 0 2px 10px", marginTop:"20px", backgroundColor:"whitesmoke"}}>
                <Downloader url={"pdf/tenders/Award_RFQ.pdf"} name={"Notification of Award - Procurement of Computers and its Peripherals, Computer Tables, Computer Chairs, Office Tables and Office Network Requirements"}/> 
                <Downloader url={"pdf/tenders/supply_computer_peripherals_18Oct2022.pdf"} name={"Supply, Installation and Commissioning of Computers and its Peripherals, Computer Tables, Computer Chairs, Office Tables and Office Network Requirements"}/> 
            </Box>
        </Box>
    )
}